import { callOnStateChange } from '../../functions/memoizedState';
import attractionsWithFilteredTickets from '../../functions/attractions/attractionsWithFilteredTickets';

export const updateAttractions = (product, currentAttractions) =>
  callOnStateChange(
    product.attractions,
    () => attractionsWithFilteredTickets(product),
    currentAttractions
  );

export const initialReceivedPublishData = {
  id: null,
  title: '',
  description: '',
  tour: {
    eventsCount: null,
  },
  images: [],
  address: '',
  locationGeo: {
    coordinates: [null, null],
  },
  finishAddress: '',
  finishLocationGeo: {
    coordinates: [null, null],
  },
  startLocation: '',
  finishLocation: '',
  distance: '',
  duration: '',
  durationMax: '',
  durationMin: '',
  locale: '',
  currency: '',
  defaultCurrency: {
    id: '',
    rate: '',
    code: '',
    symbol: '',
    name: '',
  },
  subcategories: [],
  inclusions: [],
  exclusions: [],
  price: 0,
  status: 'draft',
};

export const initialPublishingState = {
  currentPlans: [],
  paymentData: {},
  errors: [],
  isFetching: false,
  isPublishing: false,
  isSaving: false,
  isSaved: false,
  isNotSaved: false,
  skeletonsCounter: [],
  receivedPublishData: initialReceivedPublishData,
  inclusions: [],
  exclusions: [],
  highlights: [],
  priceLevels: [],
  attractions: [],
  tickets: [],
};
